module.exports = __webpack_public_path__ + "img/chat-wedget.c628eb8e.png";